/**
 * Builds an absolute URL for an in-app path.
 * Uses the admin-configured site URL stored in Supabase site_settings.
 * Falls back to a localStorage-cached URL, then to window.location.origin.
 */

const SITE_URL_CACHE_KEY = 'pinnacle_site_url';

let _configuredSiteUrl = '';

// Load cached URL from localStorage on module init so it's available immediately
// (before Supabase finishes loading site_settings)
try {
  const cached = localStorage.getItem(SITE_URL_CACHE_KEY);
  if (cached && cached.trim()) {
    _configuredSiteUrl = cached.trim().replace(/\/$/, '');
  }
} catch { /* ignore */ }

/** Called once by AppDataContext when site_settings loads from Supabase. */
export function setConfiguredSiteUrl(url: string): void {
  if (url && url.trim()) {
    _configuredSiteUrl = url.trim().replace(/\/$/, ''); // remove trailing slash
    // Persist to localStorage so email links are correct even on next load
    try {
      localStorage.setItem(SITE_URL_CACHE_KEY, _configuredSiteUrl);
    } catch { /* ignore */ }
  }
}

export function getConfiguredSiteUrl(): string {
  return _configuredSiteUrl;
}

export function siteUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  // Use the admin-configured URL (e.g. https://yoursite.com) — persisted in localStorage
  if (_configuredSiteUrl) {
    return `${_configuredSiteUrl}${cleanPath}`;
  }

  // Fallback: current browser origin
  // Note: Set your site URL in Admin → Settings → Site URL for correct email links
  return `${window.location.origin}${cleanPath}`;
}
